import { PartyForUnicefControllerService } from '@/__generated__/FrontApi';
import Button from '@/components/Button';
import InputCheckbox from '@/components/Input/InputCheckbox';
import { Tit } from '@/components/Titles';
import { breakpoint } from '@/helpers/BreakpointHelper';
import { usePopupStore } from '@/stores/PopupStore';
import React, { FC, useCallback } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import styled from 'styled-components';

const StepContainer = styled.div`
  header {
    line-height: 1.5;
    border-bottom: 1px solid #1cabe2;
    padding-bottom: 16px;
    margin-bottom: 24px;
  }
  .c-blue {
    color: #1cabe2;
  }

  .box {
    padding: 24px;
    margin-top: 24px;
    background-color: #f8f9fa;
  }
  .cnt-list {
    & > li {
      line-height: 2;
      position: relative;
      padding-left: 15px;

      &::before {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 0;
        color: #1cabe2;
      }

      &:nth-child(1) {
        &::before {
          content: '1.';
        }
      }
      &:nth-child(2) {
        &::before {
          content: '2.';
        }
      }
      &:nth-child(3) {
        &::before {
          content: '3.';
        }
      }
      &:nth-child(4) {
        &::before {
          content: '4.';
        }
      }
      &:nth-child(5) {
        &::before {
          content: '5.';
        }
      }
      &:nth-child(6) {
        &::before {
          content: '6.';
        }
      }
    }
  }

  .agree-wrap {
    margin-top: 24px;
    label {
      margin-bottom: 4px;
    }
  }

  .btn-wrap {
    margin-top: 80px;
  }
  ${breakpoint(`mobile`)} {
  }
`;

export interface PartyApplyStep3Data {
  isAgreeYn1: boolean | string;
  isAgreeYn2: boolean | string;
}
interface PartyApplyCompleteProps {
  onSubmit: (data: PartyApplyStep3Data) => void;
  data?: any;
}
const ParrtAppyStep3: FC<PartyApplyCompleteProps> = ({
  onSubmit,
  ...props
}) => {
  const {
    handleSubmit,
    register,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm<PartyApplyStep3Data>({
    defaultValues: {
      isAgreeYn1: `N`,
      isAgreeYn2: `N`,
    },
  });

  const currentChild = (data: number) => {
    props.currentParent(data);
  };

  const popupStore = usePopupStore();
  const onSubmitForm: SubmitHandler<PartyApplyStep3Data> = useCallback(
    async (formData) => {
      const totalSubmit = { ...formData, ...props.totalData };
      try {
        const {
          resultCode,
          resultMessage,
        } = await PartyForUnicefControllerService.applyPartyUsingPost(
          totalSubmit,
        );
        reset();
        currentChild(4);
        // popupStore.show(resultMessage);
      } catch {
        popupStore.show(
          `Party for UNICEF 신청에 실패했습니다. 다시 시도해주세요.`,
        );
      }
    },
    [onSubmit],
  );
  return (
    <StepContainer>
      <form onSubmit={handleSubmit(onSubmitForm)}>
        <header>
          <h3>
            <Tit size="s2">3. 활동 주의사항 동의</Tit>
          </h3>
        </header>
        <strong className="c-blue">
          Party for UNICEF 프로그램 활동 전 반드시 알아야 할 사항을 안내
          드립니다.
          {` `}
          <br />
          아래 모든 항목에 동의 후 서명하셔야 모금 파티 허가 절차가
          마무리됩니다.
        </strong>
        <div className="box">
          <ul className="cnt-list">
            <li>
              Party for UNICEF 로고 이외에 유니세프 로고를 무단으로 사용할 수
              없습니다.
            </li>
            <li>
              유니세프가 허가한 장소 및 시간에만 모금활동을 할 수 있습니다.
            </li>
            <li>
              Party for UNICEF를 사칭한 모금 행위, 후원금 갈취 등 기부 이외의
              목적으로 이윤을 추구하는 행위 시 관계법령에 따라 형사 처벌될 수
              있습니다.
            </li>
            <li>
              유니세프의 브랜드 이미지를 훼손할 수 있는 행동(지나친 음주, 흡연,
              폭력, 유해 물질 제공 등)은 절대 삼가야 합니다.
            </li>
            <li>
              모금 활동 중 일어난 사고 및 위험상황에 대한 책임은 파티 주최자에게
              있습니다.
            </li>
            <li>
              위에 명시되지 않은 기타 사항은 유니세프한국위원회와 상의하여
              진행합니다.
            </li>
          </ul>
        </div>
        <div className="agree-wrap">
          <InputCheckbox
            label="나는 유니세프한국위원회의 지원으로 투명하게 모금 활동을 하며, 모금한 금액 전부를 유니세프한국위원회에 전달하겠습니다."
            name="isAgreeYn1"
            value="Y"
            ref={register}
          />
          <InputCheckbox
            label="나는 위의 모든 유의사항을 이해하였고, 이에 동의할 것을 서약합니다."
            name="isAgreeYn2"
            value="Y"
            ref={register}
          />
        </div>
        <div className="btn-wrap">
          <Button type="submit" full>
            신청하기
          </Button>
        </div>
      </form>
    </StepContainer>
  );
};
export default ParrtAppyStep3;
